import { render, staticRenderFns } from "./NearbyEvents.vue?vue&type=template&id=3919be60&"
import script from "./NearbyEvents.vue?vue&type=script&lang=js&"
export * from "./NearbyEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports